import Layout from "@/layout";
import noneLayout from "@/layout-none";
const techincianRouter = {
  path: "/technician",
  component: Layout,
  redirect: "/technician/index",
  name: "technician",
  meta: {
    title: "家政管理",
    icon: "clipboard"
  },
  children: [
    {
      path: "insure/insureList",
      component: () => import("@/views/technician/insure/list/index"),
      name: "baoxianLiexing",
      meta: { title: "保险类型", icon: "" }
    },
    {
      path: "insure/insureRegistration",
      component: () => import("@/views/technician/insure/registration/index"),
      name: "baoxianDengji",
      meta: { title: "保险登记", icon: "" }
    },

    {
      path: "index/manage",
      component: () => import("@/views/technician/yuesao/index/manage"),
      name: "yuesaoIndex",
      meta: { title: "人员管理", icon: "" }
    },
    {
      path: "index/enter",
      component: () => import("@/views/technician/yuesao/index/enter"),
      name: "yuesaoEnter",
      meta: { title: "录入统计", icon: "" }
    },
    {
      path: "index/enterDetail/:id?",
      component: () => import("@/views/technician/yuesao/index/enterDetail"),
      name: "yuesaoEnterDetail",
      meta: {
        title: "录入详情",
        icon: "",
        activeMenu: `/technician/index/enter`,
        parentPath: "/technician/index/enter"
      }
    },
    {
      path: "tags",
      component: () => import("@/views/technician/tags/index"),
      name: "yuesaoTags",
      meta: { title: "标签管理", icon: "" }
    },
    {
      path: "levels",
      component: () => import("@/views/technician/levels/index"),
      name: "yuesaoLevel",
      meta: { title: "等级管理", icon: "" }
    },
    {
      path: "prices",
      component: () => import("@/views/technician/prices/index"),
      name: "yuesaoPrice",
      meta: { title: "服务管理", icon: "" }
    },
    {
      path: "create/:id?",
      component: () => import("@/views/technician/yuesao/create/index"),
      name: "YueshaoCreat",
      meta: {
        title: "家政添加",
        noCache: true,
        activeMenu: `/technician/index/manage`,
        parentPath: "/technician/index/manage"
      },
      hidden: true
    },
    {
      path: "deposit/:id?",
      component: () => import("@/views/technician/yuesao/deposit/index"),
      name: "YueshaoDeposit",
      meta: {
        title: "家政押金",
        noCache: true,
        activeMenu: `/technician/index/manage`,
        parentPath: "/technician/index/manage"
      },
      hidden: true
    },
    {
      path: "img/work/:id?/:name?",
      component: () => import("@/views/technician/workimgs/index"),
      name: "YueshaoWorkImg",
      meta: {
        title: "工作风采",
        noCache: true,
        activeMenu: `/technician/index/manage`,
        parentPath: "/technician/index/manage"
      },
      hidden: true
    },
    {
      path: "share/:number",
      component: () => import("@/views/technician/yuesao/share/detail"),
      name: "YueshaoShareDetail",
      meta: {
        title: "分享详情",
        activeMenu: `/technician/index/manage`,
        parentPath: "/technician/index/manage"
      }
    },
    {
      path: "share/detail/:id?",
      component: () => import("@/views/technician/yuesao/share/detail"),
      name: "YueshaoShareDetail",
      meta: {
        title: "分享详情",
        noCache: true,
        activeMenu: `/technician/index/manage`,
        parentPath: "/technician/index/manage"
      },
      hidden: true
    },
    {
      path: "img/id/:id?/:name?",
      component: () => import("@/views/technician/idimgs/index"),
      name: "YueshaoIdImg",
      meta: {
        title: "证件照",
        noCache: true,
        activeMenu: `/technician/index/manage`,
        parentPath: "/technician/index/manage"
      },
      hidden: true
    },
    {
      path: "comment/:id?/:name?",
      component: () => import("@/views/technician/comment/index"),
      name: "YueshaoCommont",
      meta: {
        title: "评论管理",
        noCache: true,
        activeMenu: `/technician/index/manage`,
        parentPath: "/technician/index/manage"
      },
      hidden: true
    },
    {
      path: "schedule/:id?/:name?",
      component: () => import("@/views/technician/schedule/index"),
      name: "yuesaoSchedule",
      meta: {
        title: "档期管理",
        noCache: true,
        activeMenu: `/technician/index/manage`,
        parentPath: "/technician/index/manage"
      },
      hidden: true
    },
    {
      path: "shareSchedule",
      component: () =>
        import("@/views/technician/schedule/components/shareSchedule"),
      name: "shareSchedule",
      meta: {
        title: "档期详情",
        activeMenu: `/technician/index/manage`,
        parentPath: "/technician/index/manage"
      }
    },
    {
      path: "message",
      component: () => import("@/views/technician/message/index"),
      name: "messageManage",
      meta: { title: "消息中心", icon: "" }
    },
    {
      path: "customer",
      component: () => import("@/views/technician/customer/index"),
      name: "customerManage",
      meta: { title: "客户管理", icon: "" }
    },
    {
      path: "user",
      component: () => import("@/views/technician/user/index"),
      name: "userManage",
      meta: { title: "用户管理", icon: "" }
    },
    {
      path: "task",
      component: () => import("@/views/technician/task/index"),
      name: "taskManage",
      meta: { title: "任务管理", icon: "" }
    }
  ]
};

export default techincianRouter;
